module.exports = "<router-outlet></router-outlet>\n "


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1